import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../tokens/is-browser.token";
import * as i2 from "@angular/common";
export class FontSizeService {
    constructor(isBrowser, document) {
        this.isBrowser = isBrowser;
        this.document = document;
        this.FONT_SIZE_KEY = 'website-font-size';
        this.DEFAULT_SIZE = 10; // 默認大小 (10px)
        this.STEP_SIZE = 2; // 每次調整的幅度 (2px)
        this.MAX_SIZE = 16; // 最大尺寸 (16px)
        this.MIN_SIZE = 6; // 最小尺寸 (6px)
        // 當前字體大小的 BehaviorSubject，可以被組件訂閱
        this._fontSize$ = new BehaviorSubject(this.DEFAULT_SIZE);
        this.fontSize$ = this._fontSize$.asObservable();
        if (this.isBrowser) {
            this.initFontSize();
        }
    }
    /**
     * 初始化字體大小設置
     */
    initFontSize() {
        const savedSize = localStorage.getItem(this.FONT_SIZE_KEY);
        if (savedSize) {
            const size = parseInt(savedSize, 10);
            this._fontSize$.next(size);
            this.applyFontSize(size);
        }
    }
    /**
     * 增加字體大小
     */
    increaseFontSize() {
        const currentSize = this._fontSize$.value;
        if (currentSize < this.MAX_SIZE) {
            let newSize = currentSize + this.STEP_SIZE;
            newSize = Math.min(newSize, this.MAX_SIZE);
            this._fontSize$.next(newSize);
            this.applyFontSize(newSize);
            this.saveFontSize(newSize);
        }
    }
    /**
     * 減小字體大小
     */
    decreaseFontSize() {
        const currentSize = this._fontSize$.value;
        if (currentSize > this.MIN_SIZE) {
            let newSize = currentSize - this.STEP_SIZE;
            newSize = Math.max(newSize, this.MIN_SIZE);
            this._fontSize$.next(newSize);
            this.applyFontSize(newSize);
            this.saveFontSize(newSize);
        }
    }
    /**
     * 重置字體大小到默認值
     */
    resetFontSize() {
        this._fontSize$.next(this.DEFAULT_SIZE);
        this.applyFontSize(this.DEFAULT_SIZE);
        this.saveFontSize(this.DEFAULT_SIZE);
    }
    /**
     * 應用字體大小到整個網站
     */
    applyFontSize(size) {
        // 通過 CSS 變量設定字體大小
        this.document.documentElement.style.setProperty('--font-size-scale', `${size / 16}em`);
    }
    /**
     * 保存字體大小設置到本地存儲
     */
    saveFontSize(size) {
        localStorage.setItem(this.FONT_SIZE_KEY, size.toString());
    }
}
FontSizeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FontSizeService_Factory() { return new FontSizeService(i0.ɵɵinject(i1.IS_BROWSER_TOKEN), i0.ɵɵinject(i2.DOCUMENT)); }, token: FontSizeService, providedIn: "root" });
